<template>
  <section id="hero-1785">
    <div class="cs-container">
      <div class="cs-content">
        <h1 class="cs-title">Compassionate Care, Empowered Lives</h1>
        <p class="cs-text">
          We are dedicated to providing compassionate, reliable, and inclusive support that empowers individuals with disabilities to live with dignity, independence, and joy.
        </p>
        <div class="cs-button-group">
          <a href="/contact" class="cs-button-solid cs-button1">Contact Us</a>
        </div>
      </div>
    </div>

    <!-- Background Image -->
    <picture class="cs-background">
      <source media="(max-width: 600px)" srcset="../assets/images/home-1.jpg">
      <source media="(min-width: 601px)" srcset="../assets/images/home-1.jpg">
      <img loading="lazy" decoding="async" src="../assets/images/home-1.jpg" alt="hero-image" width="1920" height="1200" aria-hidden="true">
    </picture>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>

<style scoped>

/*-- -------------------------- -->
<---           Hero             -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
#hero-1785 {
  height: 100vh; /* Ensure section fits viewport height */
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: clamp(12.5rem, 25.95vw, 18.75em) 1rem; /* Keep original padding logic */
  position: relative;
  z-index: 1;
  overflow: hidden; /* Prevents unwanted scroll */
}

#hero-1785 .cs-container {
  width: 100%;
  max-width: 80rem;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 3rem;
}

#hero-1785 .cs-content {
  text-align: center;
  width: 100%;
  max-width: 46.875rem;
}

#hero-1785 .cs-title {
  font-size: clamp(3.0625rem, 6vw, 3.5rem);
}

#hero-1785 .cs-title,
#hero-1785 .cs-text {
  color: var(--bodyTextColorWhite);
}

#hero-1785 .cs-text {
  margin-bottom: 2rem;
}

#hero-1785 .cs-button-group {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

#hero-1785 .cs-button-solid {
  font-size: 1rem;
  font-weight: 700;
  line-height: clamp(2.875rem, 5.5vw, 3.5rem);
  text-align: center;
  text-decoration: none;
  min-width: 12.5rem;
  margin: 0;
  box-sizing: border-box;
  padding: 0 1.5rem;
  background-color: var(--primary);
  color: var(--bodyTextColorWhite);
  border-radius: 0.25rem;
  display: inline-block;
  position: relative;
  z-index: 1;
}

#hero-1785 .cs-button-solid:before {
  content: "";
  width: 0%;
  height: 100%;
  background: #000;
  opacity: 1;
  border-radius: 0.25rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  transition: width 0.3s;
}

#hero-1785 .cs-button-solid:hover:before {
  width: 100%;
}

#hero-1785 .cs-graphic {
  width: 100%;
  min-width: 120rem;
  height: auto;
  object-fit: cover;
  position: absolute;
  bottom: 0;
  left: 50%;
  z-index: 0;
  transform: translateX(-50%);
}

#hero-1785 .cs-graphic-dark {
  display: none;
}

#hero-1785 .cs-background {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
}

#hero-1785 .cs-background:before {
  content: "";
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.7;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}

#hero-1785 .cs-background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}
}

/* Large Desktop - 1920px */
@media only screen and (min-width: 120rem) {
#hero-1785 {
  height: 100vh;
  max-height: 100vh;
  padding-bottom: 14vw;
}
}

</style>
